import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Formate un nom/prénom : chaque mot avec 1re lettre en majuscule, le reste en minuscule.
// Gère les séparateurs espace, tiret et apostrophe (ex: "jean-pierre" -> "Jean-Pierre").
export function titleCaseName(value = "") {
  return value
    .toLowerCase()
    .replace(/(^|[\s\-'’])([\p{L}])/gu, (_, sep, chr) => sep + chr.toUpperCase());
}
